<template>
  <div class="app-main-content" type="primary">
    <div
      class="grid-view"
    >
      <div class="main-content">
        <search-item
          ref="searchItem"
          config-module="3200"
          :reset="true"
          :show-adv="true"
          :show-simple="false"
          :expand-adv="true"
          :custom-search-items="customSearchItems"
          :custom-sim-query-placeholder="$t('Message.QuickSearchBusinessNo')"
          @click-more="value=>isAdvancedQuery=value"
          @advSearchItemCallBack="toAdvancedQuery"
          @advSearchItemResetCallBack="toAdvancedQuery"
        >
          <div slot="operations">
            <el-checkbox v-model="needRequire" no="4" @change="toQuery">{{ $t('CargoMsg.Cargo_CostVirtualImplementationToConsolidationPlan') }}</el-checkbox>
          </div>
        </search-item>
        <div class="section grid-wrapper">
          <cargo-ag-grid
            config-module="24000522"
            :grid-params.sync="gridParams"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :show-side-bar="false"
            :row-data="rowData"
            @gridReady="params=>gridApi=params.api"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import URL from '@/api/urlTranslator'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { routeProductRevenueStatisticsFunc } from '@/api/AirExport/airExportJob'
import ColumnUtils from '@/utils/ColumnUtils'
import { queryAirlineProductDownList } from '@/api/booking/airlineProduct'
import { formatNumberToThousands } from '@/utils'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import AdvancedSearchConsts from '@/class/cargo/model/parameters/OperatorConstants'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'

export default {
  name: 'RouteProductRevenueStatistics',
  components: {
    searchItem
  },
  data() {
    return {
      URL,
      isAdvancedQuery: true, // 是否为高级查询
      pageCount: 0,
      SystemConstants: SystemConstants,
      airlineProductDownList: [], // 航线产品 下拉
      customSearchItems: [],
      filter: {
        conditions: [],
        total: 0,
        pageNum: 1,
        pageSize: 10000
      },
      templateName: null,
      filterJson: {},
      selectData: null,
      fullscreenLoading: null,
      needRequire: true,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
        suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择。当您想要专门选择复选框时使用。
        treeData: true,
        groupDefaultExpanded: 4,
        getDataPath: data => {
          return data.path.split(',')
        },
        context: {
          componentParent: this
        },
        defaultColDef: {
          minWidth: 80,
          menuTabs: [], // 去掉每列的菜单
          sortable: false // 去掉每列的排序
        },
        autoGroupColumnDef: {
          headerName: this.$t('CargoMsg.Cargo_AirlineProductCode'),
          field: 'airlineProductName',
          tooltipValueGetter: (params) => {
            return ''
          },
          pinned: 'left',
          width: 140,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          suppressMovable: true,
          cellRendererParams: {
            suppressCount: true,
            suppressDoubleClickExpand: true,
            checkbox: params => {
              return false
            },
            innerRenderer: params => {
              const data = params.data
              if (data.dataType === 1) {
                return data.airlineProductName
              } else {
                return ''
              }
            }
          }
        },
        // 选中
        onRowClicked: (event) => {
          this.selectData = event.data
        }
      },
      gridParams: {},
      gridApi: null,
      rowData: []
    }
  },
  computed: {
    columnDefs() {
      const list1 = [{
        headerName: this.$t('CargoMsg.Cargo_ServiceProduct'),
        colId: 'serviceProduct',
        field: 'serviceProduct',
        suppressMovable: true,
        pinned: 'left',
        width: 150,
        cellRenderer: (params) => {
          if (params.data.dataType !== 1) {
            return ''
          }
          return params.value
        }
      },
      {
        headerName: this.$t('CargoMsg.Cargo_Flight'),
        colId: 'flightDate',
        field: 'flightDate',
        suppressMovable: true,
        pinned: 'left',
        width: 100,
        cellRenderer: (params) => {
          if (params.data.dataType !== 2) {
            return ''
          }
          return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd')
        }
      }]
      const list2 = [{
        headerName: this.$t('CargoMsg.Cargo_ContainerGroup'),
        colId: 'apuName',
        field: 'apuName',
        pinned: 'left',
        suppressMovable: true,
        width: 250,
        cellRenderer: (params) => {
          if (params.data.dataType !== 3) {
            return ''
          }
          return params.value
        }
      }]
      const list3 = [
        {
          headerName: this.$t('CargoMsg.Cargo_MblNo'),
          colId: 'mblNo',
          field: 'mblNo',
          suppressMovable: true,
          width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_OrderNumber'),
          colId: 'jobNo',
          field: 'jobNo',
          suppressMovable: true,
          width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_BaseWeight'),
          colId: 'basicWeight',
          field: 'basicWeight',
          suppressMovable: true,
          width: 150,
          cellRenderer: (params) => {
            if (![1, 2].includes(params.data.dataType)) {
              return ''
            }
            return formatNumberToThousands(ColumnUtils.formatNumber(params.value, 3, false, true), 3)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_LimitWeight'),
          colId: 'limitWeight',
          field: 'limitWeight',
          suppressMovable: true,
          width: 150,
          cellRenderer: (params) => {
            if (![1, 2].includes(params.data.dataType)) {
              return ''
            }
            return formatNumberToThousands(ColumnUtils.formatNumber(params.value, 3, false, true), 3)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_AssemblyGrossWeight'),
          colId: 'weightAssembly',
          field: 'weightAssembly',
          suppressMovable: true,
          width: 150,
          cellRenderer: (params) => {
            return formatNumberToThousands(ColumnUtils.formatNumber(params.value, 3, true, true), 3)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_TheoreticalVolume'),
          colId: 'theoryVolume',
          field: 'theoryVolume',
          suppressMovable: true,
          width: 150,
          cellRenderer: (params) => {
            if (![1, 2].includes(params.data.dataType)) {
              return ''
            }
            return formatNumberToThousands(ColumnUtils.formatNumber(params.value, 3, false, true), 3)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_AssemblyVolume'),
          colId: 'cubAgeAssembly',
          field: 'cubAgeAssembly',
          suppressMovable: true,
          width: 150,
          cellRenderer: (params) => {
            return formatNumberToThousands(ColumnUtils.formatNumber(params.value, 3, true, true), 3)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_AssemblyChargeableWeight'),
          colId: 'chargeWeightAssembly',
          field: 'chargeWeightAssembly',
          suppressMovable: true,
          width: 150,
          cellRenderer: params => {
            return ColumnUtils.formatNumber(params.value, 3, true, true)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Revenue'),
          colId: 'income',
          field: 'income',
          suppressMovable: true,
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.number2ColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_PrimeCost'),
          colId: 'cost',
          field: 'cost',
          suppressMovable: true,
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.number2ColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_GrossProfit'),
          colId: 'realProfit',
          field: 'realProfit',
          suppressMovable: true,
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.number2ColumnLabelFunc(params.value)
          }
        }
      ]
      if (!this.needRequire) {
        return [...list1, ...list3]
      } else {
        return [...list1, ...list2, ...list3]
      }
    }
  },
  async created() {
    await this.init()
  },
  methods: {
    async init() {
      // 初始化 航线产品下拉列表
      await queryAirlineProductDownList({ containVoyage: false, branchId: this.$store.getters.currentOfficeId }).then(res => {
        this.airlineProductDownList = res.data
      })
      this.customSearchItems = await this.getCustomSearchItems()
    },
    async getCustomSearchItems() {
      const defaultSearchFields = []
      const searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.ADD_ACTION
      searchField.itemType = 'advanceSelect'
      searchField.multiple = 0
      searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_IN]
      searchField.defaultConditionVal = 0
      searchField.fieldType = 'FIELD_TEXT2'
      searchField.itemName = 'ap.AIRLINE_PRODUCT_UUID'
      searchField.itemLabel = 'CargoMsg.Cargo_AirlineProductCode'
      searchField.itemValue = []
      searchField.defaultSelected = 1
      searchField.selected = 0
      searchField.dropdownDataRef = ''
      searchField.tagName = 'name'
      searchField.tagValue = 'uuid'
      searchField.lock = false
      searchField.defaultValue = []
      searchField.dataProvider = this.airlineProductDownList
      defaultSearchFields.push(searchField.formatObj2Json())
      return defaultSearchFields
    },
    toQuery() {
      this.toAdvancedQuery(this.filter.snapshotConditions)
    },
    handleQueryData(res) {
      this.rowData = res.data.list
      for (const data of this.rowData) {
        data.airlineProductName = ''
        if (data.dataType === 1) {
          data.airlineProductName = ColumnUtils.getAirLineProductLabelFunc(data.airlineProductUuid, this.airlineProductDownList)// 航线产品
        }
      }
      this.pageCount = res.data.pages
      this.filter.pageNum = res.data.pageNum
      this.filter.pageSize = res.data.pageSize
      this.filter.total = Number(res.data.total)
      this.fullscreenLoading.close()
    },
    toAdvancedQuery(data) {
      if (typeof data !== 'undefined') {
        this.filter.snapshotConditions = data
        // 高级查询条件组装
        this.filter.conditions = data
        this.filter.pageNum = 1
      }
      if (!AdvancedSearchOption.hasField('ap.FLIGHT_DATE', this.filter.conditions)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseFill') + this.$t('CargoMsg.Cargo_FlightDateRange'))
        return
      }
      const condition = AdvancedSearchOption.getOption('ap.FLIGHT_DATE', this.filter.conditions)
      if (condition && condition.value && (!condition.value.includes('start=') || !condition.value.includes('end='))) {
        this.$message.warning(this.$t('CargoMsg.Cargo_FlightDateRange') + this.$t('CargoMsg.Cargo_MustEnterComplete'))
        return
      }
      this.filterJson.conditions = this.filter.conditions
      this.filterJson.pageNum = this.filter.pageNum
      this.filterJson.pageSize = this.filter.pageSize
      this.filterJson.branchId = this.$store.getters.currentOfficeId

      this.filterJson.requires = []
      if (!this.needRequire) {
        this.filterJson.requires = ['routeProductRevenueStatistics']
      } else {
        const option = new AdvancedSearchOption(null, 'ap.STATUS', [SystemConstants.ASSEMBLY_PLAN_STATUS_CONFIRMED.code], AdvancedSearchConsts.OPERATOR_IN.code)
        this.filterJson.conditions.push(option.formatObj2Json())
      }
      this.fullscreenLoading = getLoading4Cxt()
      routeProductRevenueStatisticsFunc(this.filterJson).then((res) =>
        this.handleQueryData(res)
      ).finally(() => {
        this.fullscreenLoading.close()
      })
    }
  }
}
</script>
